<template>
  <v-text-field v-bind="$props" v-on="$listeners" class="rounded-lg">
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-text-field>
</template>

<script>
import { VTextField } from "vuetify/lib"

export default {
  extends: VTextField,

  props: {
    solo: { default: true },
    dense: { default: true },
    "hide-details": { default: true },
  },
}
</script>
